import axios from "axios";
import serverMessage from "../server-message";

// An approve carries `company_bundle_id`, which may name a bundle the wizard created moments
// earlier — so a rejection here can leave a bundle nobody holds. The putApproval middleware
// alerts action.payload; reject with the server's reason, not axios's status-code string.
export default function putApproval({
  id,
  status,
  remarks,
  rejectModules,
  planUuid,
  bundle,
  isTestingAccount,
  expireDate,
  salesEmail,
  sa,
}) {
  return new Promise((resolve, reject) =>
    axios
      .put(`/account/system-admin/api/v1/approval/${id}`, {
        status,
        remarks,
        reject_modules: rejectModules,
        plan_uuid: planUuid,
        company_bundle_id: bundle,
        is_testing_account: isTestingAccount,
        expired_at: expireDate,
        sales_email: salesEmail,
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(serverMessage(error)))
  );
}
